<template>
  <div class="oneCategory" v-if="categoryDefault">
    <Crumb :first-crumb="categoryDefault.showCategory?.name"></Crumb>
    <div v-if="categoryDefault.showCategory?.imageUrl" class="categoryBanner">
      <img class="hidden-xs" :alt="categoryDefault.showCategory?.name" :src="getCategoryImageUrl(categoryDefault.showCategory?.imageUrl)" />
      <h2 class="hidden-sm hidden-md">{{ categoryDefault.showCategory?.name }}</h2>
      <div v-html="categoryDefault.categoryDesc"></div>
    </div>

    <div class="categoryShow">
      <div class="subCaregory">
        <h2><span>Sub-Categories for the {{ categoryDefault.showCategory?.name }}</span></h2>
        <ul class="clearfix">
          <li v-for="(c, index) in categoryDefault.subCategories" :key="index">
            <p class="proImg">
              <a :title="c.category.name.decodeHtml()" :href="c.catUrl">
                <img :src="getCategoryImageUrl(c.category?.imageUrl)" :alt="c.category.name.decodeHtml()" />
              </a>
            </p>
            <p class="proName">
              <a :href="c.catUrl">{{ c.category.name.decodeHtml() }}</a>
            </p>
          </li>
        </ul>
      </div>
      <div class="showList">
        <h2><span>Hot items in {{ categoryDefault.showCategory?.name }}</span></h2>
        <ul class="clearfix">
          <li v-for="(item, index) in categoryDefault.hotSellProducts" :key="index" :class="{ 'itemLast': (index + 1) % 5 === 0 }">
            <p class="proImg">
              <span class="GoCart AddToCartBtn" v-addToCart.stop="{ id: item.id, qty: 1 }"></span>
              <span class="buyNow buyNowBtn" v-buyNow.stop="{ id: item.id, qty: 1 }"></span>
              <span v-if="!item.wishId" class="Collect addToWishListBtn" v-hoverAddToWishList.stop="item.id"></span>
              <span  v-if="item.wishId" class="Collect addToWishListBtn ViewMyWishList Collection"  v-hoverAddToWishList.stop="item.id"  :id="item.wishId" ></span>
              <span v-if="item.isPoolProduct" class="Hot"></span>
              <a :title="item.name.decodeHtml()"  :href="getProductDetailUrl(item.id, item.name) + '?paLb=Rec_HotItems'">
                <img :src="getPhotoUrl(item.mainImageName, 285, 285)" />
              </a>
            </p>
            <p class="proName">
              <a :title="item.name.decodeHtml()"  :href="getProductDetailUrl(item.id, item.name) + '?paLb=Rec_HotItems'">
                <span v-if="item.isPromotion" class="discountBg">{{ item.discount}}% OFF</span>
                {{ getLimitStringByWord(item.name.decodeHtml(), 50) }}
              </a>
            </p>
            <p class="proPrice">
              <template v-if="item.salePrice2 > 0">
                            <span class="newPrice">
                               {{ item.salePrice3 > 0 ? item.finalSalePrice3.money() : item.finalSalePrice2.money() }} - {{ item.finalSalePrice.money() }}
                            </span>
              </template>
              <template v-else-if="item.isPromotion || !isEqual(item.finalSalePrice,item.salePrice)">
                <span class="newPrice">{{ item.finalSalePrice.money() }} /&nbsp;{{ getUnitString(item.unitQuantity, item.unit) }}</span>
                <span class="oldPrice">{{ item.salePrice.money() }} /&nbsp;{{ getUnitString(item.unitQuantity, item.unit) }}</span>
              </template>
              <template v-else>
                <span class="newPrice">{{ item.salePrice.money() }}</span>
              </template>
            </p>
          </li>
        </ul>
        <a class="moreLink" :href="getBestSellerProductListUrl(categoryDefault.showCategory.id, categoryDefault.showCategory.name)+ '?sort=13'">View More &gt;&gt;</a>
      </div>
    </div>
  </div>
</template>
<script src="./Category.ts"></script>
<style src="./category.less" lang="less" scoped></style>